<template>
  <div>
    <div class="section-subtitle m-t-10 m-b-5">TrueMoney Wallet</div>
    <div class="box-link truewallet">
      <img
        src="@/assets/images/truewallet.png"
        @click="isImageModalActive = true"
      />
      <div class="bank-detail m-t-10">
        <div class="field m-t-10">
          <div class="control has-icons-left">
            <input
              v-model="link"
              type="text"
              :placeholder="$t('modals.deposit.linkTruePla')"
              class="input text-center"
            />
            <span class="icon is-left">
              <i class="fas fa-link"></i>
            </span>
          </div>
        </div>
        <button
          type="button"
          class="button small is-success m-l-10"
          @click="sendLink"
          :disabled="!link"
        >
          {{ $t('modals.deposit.linkSendBtn') }}
        </button>
      </div>
    </div>

    <b-modal :active.sync="isImageModalActive">
      <p class="image full-screen">
        <img src="@/assets/images/truewallet.png" />
      </p>
    </b-modal>
  </div>
</template>

<script>
import i18n from '@/language'

import apiWallet from '@/api/wallet'

export default {
  name: 'ModalDeposit',
  props: {
    walletAccounts: {
      type: Array
    }
  },
  data() {
    return {
      link: '',
      isImageModalActive: false
    }
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    },
    sendLink() {
      if (this.link) {
        let loading = this.$loading.show()

        setTimeout(async () => {
          try {
            const data = await apiWallet.trueLink(this.link)
            if (data) {
              this.$buefy.toast.open({
                message: i18n.t('modals.deposit.linkSendMsg'),
                type: 'is-success'
              })
            }

            loading.hide()

            this.$emit('closeModal', null)
          } catch (error) {
            this.$buefy.toast.open({
              message: error.message ? error.message : error,
              type: 'is-danger'
            })
            loading.hide()
          }
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box-link {
  text-align: center;
  padding: 15px;
  border-radius: 10px;
  color: white;
  margin: 10px 0;

  img {
    width: 100%;
    max-width: 250px;
  }
}

.truewallet {
  background: linear-gradient(#d83b34 25%, #e3783c 100%);
}
</style>
